import { render, staticRenderFns } from "./COD-Split.vue?vue&type=template&id=a7f882e6&scoped=true"
import script from "./COD-Split.vue?vue&type=script&lang=js"
export * from "./COD-Split.vue?vue&type=script&lang=js"
import style0 from "./COD-Split.vue?vue&type=style&index=0&id=a7f882e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f882e6",
  null
  
)

export default component.exports